<div class="ui cards"
     style="min-height: 15em;">
    <div class="card p-3" style="box-shadow: none;">
        @switch (rota() ?? 'ana-sayfa') {
        @case ("ana-sayfa") {
        <div class="content mb-3">
            <div class="flex justify-content-center flex-wrap">
                <img [src]="servisUyar.logoBuyukUrl()"
                     height="76"
                     class="shadow-3 "
                     class="py-beyaz-arka" />
            </div>
        </div>
        <div class="flex justify-content-center flex-wrap mb-3"
             style="row-gap: 5px;">
            <button class="basic ui button text-color-secondary w-6rem  hoverable hover:zipla-5 active:zipla-5"
                    (click)="tiklandiFirmaOlustur();">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <div style="height: 2.5rem;border-radius: 3px; font-size: 3em;">🏭</div>
                    <span class="text-sm mt-2">Firma Oluştur</span>
                </div>
            </button>
            <button class="basic ui button text-color-secondary w-6rem  hoverable hover:zipla-5 active:zipla-5"
                    (click)="tiklandiPersonelEkle();">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <div style="height: 2.5rem;border-radius: 3px; font-size: 3em;">👩‍🎓</div>
                    <span class="text-sm mt-2">Personel Ekle</span>
                </div>
            </button>
            <button class="basic ui button text-color-secondary w-6rem  hoverable hover:zipla-5 active:zipla-5"
                    (click)="tiklandiTeklifOlustur();">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <div style="height: 2.5rem;border-radius: 3px; font-size: 3em;">💍</div>
                    <span class="text-sm mt-2">Teklif Oluştur</span>
                </div>
            </button>
            <button class="basic ui button text-color-secondary w-6rem  hoverable hover:zipla-5 active:zipla-5"
                    (click)="rota.set('siparis');">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <div style="height: 2.5rem;border-radius: 3px; font-size: 3em;">🛒</div>
                    <span class="text-sm mt-2">Sipariş Oluştur</span>
                </div>
            </button>
            <button class="basic ui button text-color-secondary w-6rem  hoverable hover:zipla-5 active:zipla-5"
                    (click)="rota.set('hareket');">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <div style="height: 2.5rem;border-radius: 3px; font-size: 3em;">🌀</div>
                    <span class="text-sm mt-2">Hareket Oluştur</span>
                </div>
            </button>
            <button class="basic ui button text-color-secondary w-6rem  hoverable hover:zipla-5 active:zipla-5"
                    (click)="rota.set('fiko-zek');">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <div style="height: 2.5rem;border-radius: 3px; font-size: 3em;">🧠</div>
                    <span class="text-sm mt-2">FikoZek</span>
                </div>
            </button>
        </div>
        }

        @default {
        <fikoyt-parametreler #parametrelerBilesen
                             [(parametreler)]="icerik.ek.parametreler"></fikoyt-parametreler>

        }

        <!-- @case ("firma-olustur") {
        <div class="content mb-3 ">
            <fikoyt-uyar-firma-ekle #firmaEkleBilesen
                                    [(rota)]="rota"
                                    (ngModelChange)="CD.detectChanges();">
            </fikoyt-uyar-firma-ekle>
        </div>
        }

        @case ("teklif-olustur") {
        <div class="content mb-3 ">
            <fikoyt-uyar-teklif-olustur #teklifEkleBilesen
                                        [(rota)]="rota"
                                        (ngModelChange)="CD.detectChanges();">
            </fikoyt-uyar-teklif-olustur>
        </div>
        }
        @case ("personel-ekle") {
        <div class="content mb-3 ">
            <fikoyt-uyar-personel-ekle #personelEkleBilesen
                                        [(rota)]="rota"
                                        (ngModelChange)="CD.detectChanges();">
            </fikoyt-uyar-personel-ekle>
        </div>
        }

        @case ("siparis-olustur") {
        <div class="content mb-3">
            <div class="flex justify-content-center flex-wrap">
                <img [src]="servisUyar.logoBuyukUrl()"
                     height="76"
                     class="shadow-3 "
                     class="py-beyaz-arka"
                     (click)="rota.set('ana-sayfa');" />
            </div>
            <div class="text-sm mt-2 text-center">Sipariş Oluştur</div>
        </div>
        }

        @case ("hareket-olustur") {
        <div class="content mb-3">
            <div class="flex justify-content-center flex-wrap">
                <img [src]="servisUyar.logoBuyukUrl()"
                     height="76"
                     class="shadow-3 "
                     class="py-beyaz-arka"
                     (click)="rota.set('ana-sayfa');" />
            </div>
            <div class="text-sm mt-2 text-center">Hareket Oluştur</div>
        </div>
        }
        @case ("fiko-zek") {
        <div class="content mb-3">
            <div class="flex justify-content-center flex-wrap">
                <img [src]="servisUyar.logoBuyukUrl()"
                     height="76"
                     class="shadow-3 "
                     class="py-beyaz-arka"
                     (click)="rota.set('ana-sayfa');" />
            </div>


        </div>
        } -->
        }

        @if (rota()!="ana-sayfa") {
        <button class="circular ui mini icon button"
                style="position: absolute;top: 0;left: 0;width: 42px;"
                nz-wave
                (click)="rota.set('ana-sayfa');icerik.ek.parametreler=[];">
            <i class="arrow left icon">
            </i>
        </button>
        }
    </div>
</div>